/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash'

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SearchAllUsers(userName, isExternal) {

  const response = await $.soap({
    body: {
      SearchAllUsers: {
        $xmlns: 'http://dla.mil/ems/bpm/user',
        UserName: userName,
        IsExternal: isExternal
      }
    },
    blueprintArrays: ['SearchAllUsersResponse.Response.tuple.old.rowset.row'],
    blueprint: {
        isExternal: '$..IsExternal',
        users: [
            '$..old.rowset.row',
            {
                id: '$.ID',
                firstName: '$.FirstName',
                lastName: '$.LastName',
                isExternal: '$..IsExternal'
            }
        ]
    }
  });

  _.each(response.users, (user) => { user.isExternal = response.isExternal });
  delete response.isExternal;

  cleanUpResponse(response);
  return response;
}
